/*
  7Raw global runtime: window.R7
  - R7.layers: stack of open overlays (mega menu, search, mobile menu). Escape closes the top-most one.
      R7.layers.push(id, closeFn)  register an open layer (re-pushing an id moves it to the top)
      R7.layers.remove(id)         unregister it when it closes by any other means
      R7.layers.closeTop()         close the top-most layer; returns true when one was closed
    A layer that handles Escape itself should call event.preventDefault() so the stack skips it.
  - R7.prefersReducedMotion(): true only when the theme respects the device setting (html.r7-rm, Theme
    settings > 7Raw) and the reduced-motion media query matches.
  - R7.normalize(str): lower-case text without diacritics ("Forêt" → "foret"), for search matching.
*/
(() => {
  if (window.R7) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const stack = [];

  const layers = {
    push(id, closeFn) {
      this.remove(id);
      stack.push({ id, close: closeFn });
    },
    remove(id) {
      const index = stack.findIndex((layer) => layer.id === id);
      if (index !== -1) stack.splice(index, 1);
    },
    closeTop() {
      const layer = stack.pop();
      if (!layer) return false;
      layer.close();
      return true;
    },
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    if (layers.closeTop()) event.preventDefault();
  });

  window.R7 = {
    layers,
    prefersReducedMotion: () => document.documentElement.classList.contains('r7-rm') && reducedMotion.matches,
    normalize: (str) =>
      String(str ?? '')
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .toLowerCase(),
  };
})();
